import $axios from '../../axios'
import MobileDetect from 'mobile-detect'
import _some from 'lodash/some'

const moduleProfile = {
    state: {
        profile: {
            id: '',
            firstname: '',
            lastname: '',
            roles: [],
        },
        users: [],
        token: '',
        loggedAt: null,
        passwordUpdated: false,
        md: null,
        online: true,
        loadingUser: false
    },
    mutations: {
        updateUser: (state, params) => {
            state.profile = params
        },
        setUsers: (state, data) => {
            state.users = data
        },
        editUsername: (state, params) => {
            state.profile.firstName = params.firstName
            state.profile.lastName = params.lastName
        },
        editEmail: (state, email) => {
            state.profile.email = email
        },
        editPasswordCsrf: (state, csrf) => {
            state.passwordCsrf = csrf
        },
        updatedPassword: state => {
            state.passwordUpdated = true
        },
        setToken: (state, newToken) => {
            state.token = newToken
            const now = new Date().getTime()
            state.loggedAt = now
        },
        setOnline: (state, status) => {
            state.online = status
        },
        setMd: state => {
            state.md = new MobileDetect(window.navigator.userAgent)
        },
        toogleLoadingUser: state => {
            state.loadingUser = !state.loadingUser
        }
    },
    actions: {
        fetchProfile: context =>
            new Promise((resolve, reject) => {
                context.commit('toogleLoadingUser')
                $axios.get('/api/user/profile').then(response => {
                    context.commit('updateUser', response.data)
                    context.commit('toogleLoadingUser')
                    resolve()
                })
            }),
        fetchUsers: (context, params) => {
            $axios.get('/api/user/fetch').then(response => {
                    context.commit('setUsers', response.data)
                })
        },
        updateUsername: (context, params) => {
            $axios
                .post('/api/profile/updateUsername', params)
                .then(response => {
                    context.commit('editUsername', params)
                })
        },
        updateEmail: (context, email) => {
            const params = {}
            params.email = email
            $axios
                .post('/api/profile/updateEmail', params)
                .then(response => {
                    context.commit('editEmail', email)
                })
        },
        updatePassword: ({ commit, getters }, passwords) => {
            const params = new URLSearchParams()
            params.append(
                'fos_user_resetting_form[plainPassword][first]',
                passwords[0]
            )
            params.append(
                'fos_user_resetting_form[plainPassword][second]',
                passwords[1]
            )
            $axios
                .post('/api/profile/updatePassword', params)
                .then(response => {
                    commit('updatedPassword')
                })
                .catch(error => {
                    console.log(error)
                })
        }
    },
    getters: {
        profile: state => state.profile,
        users: state => state.users,
        token: state => state.token,
        isLogged: state => {
            const loggedAt = state.loggedAt + 604800 * 1000
            const dateUTC = new Date().getTime()
            let isLogged = state.token !== '' &&
                state.loggedAt !== null &&
                loggedAt > dateUTC
            return isLogged
        },
        loggedAt: state => state.loggedAt,
        isOnline: state => state.online,
        isMobile: state => {
            if (state.md !== undefined && state.md !== null) {
                return state.md.mobile() !== null
            }
            return false
        },
        isPhone: state => {
            if (state.md !== undefined && state.md !== null) {
                return state.md.phone() !== null && state.md.tablet() === null
            }
            return false
        },
        isLoadingUser: state => state.loadingUser,
        isUserAdmin: state => {
            return state.profile.roles.indexOf('ROLE_ADMIN') > -1
        }
    }
}

export default moduleProfile
